import './space-slider.scss'
import clsx from 'clsx'
import Link from 'next/link'
import { FC } from 'react'
import 'swiper/css'
import 'swiper/css/a11y'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { SpaceSliderData } from '@/screens/SpaceIport/page/data'

import arrowIcon from '@/shared/assets/icons/arrow.svg'
import { useSwiperRef } from '@/shared/lib/hooks/useSwiperRef'
import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { Icon } from '@/shared/ui/icon'
import { Image } from '@/shared/ui/Image'

import styles from './SpaceSlider.module.scss'

export const SpaceSlider: FC = () => {
	const [nextEl, nextElRef] = useSwiperRef<HTMLButtonElement>()
	const [prevEl, prevElRef] = useSwiperRef<HTMLButtonElement>()

	return (
		<div className={styles.slider} id="spaceSlider">
			<h2 className={styles.mainTitle}>Смотрите, сколько возможностей</h2>
			<Swiper
				modules={[Navigation]}
				navigation={{
					prevEl,
					nextEl
				}}
				spaceBetween={20}
				slidesPerView={'auto'}>
				<SwiperSlide className={styles.emptySlide}>
					<article className={styles.emptySlide} />
				</SwiperSlide>
				{SpaceSliderData.map(item => (
					<SwiperSlide key={item.title} className={styles.swiperSlide}>
						<Link prefetch={false} href={item.link} target="_blank" title={item.title}>
							<article className={styles.slide}>
								<Image alt={item.title} src={item.imageSrc} width={80} height={80} className={styles.image} />
								<h3 className={styles.title} dangerouslySetInnerHTML={createMarkup(item.title)} />
							</article>
						</Link>
					</SwiperSlide>
				))}
			</Swiper>

			<div className={styles.navigation}>
				<button ref={prevElRef} className={clsx(styles.navigationButton, styles.prev)}>
					<Icon icon={arrowIcon} width={40} height={40} />
				</button>
				<button ref={nextElRef} className={styles.navigationButton}>
					<Icon icon={arrowIcon} width={40} height={40} />
				</button>
			</div>
		</div>
	)
}
